import type { CSSProperties } from 'react';

import { kindColor, parseVersionMeta } from './versionMeta';

// Renders a version's summary + the agent-authored list of changes
// (constraints / assumptions / parameters / objective tweaks), each with a
// kind badge. Used in the compare modal (before & after) and the per-version
// details popover so a version is shown as its full set of constraints, not
// just its title.

interface Props {
  dynamicMetadata: Record<string, unknown> | null | undefined;
  emptyNote?: string;
}

function badge(color: string): CSSProperties {
  return {
    fontSize: 10,
    fontWeight: 700,
    textTransform: 'uppercase',
    letterSpacing: '0.02em',
    color: '#fff',
    background: color,
    borderRadius: 4,
    padding: '1px 6px',
    whiteSpace: 'nowrap',
    height: 'fit-content',
    marginTop: 2,
  };
}

export function VersionMetaList({ dynamicMetadata, emptyNote }: Props) {
  const meta = parseVersionMeta(dynamicMetadata);
  return (
    <div>
      {meta.summary ? (
        <p style={{ fontSize: 13, color: '#475569', margin: '0 0 8px', lineHeight: 1.5 }}>
          {meta.summary}
        </p>
      ) : null}
      {meta.changes.length ? (
        <ul style={{ margin: 0, padding: 0, listStyle: 'none' }}>
          {meta.changes.map((c, i) => (
            <li
              key={`${c.label}-${i}`}
              style={{ display: 'flex', gap: 6, fontSize: 13, lineHeight: 1.5, marginBottom: 5 }}
            >
              {c.kind ? <span style={badge(kindColor(c.kind))}>{c.kind}</span> : null}
              <span>{c.label}</span>
            </li>
          ))}
        </ul>
      ) : (
        <p style={{ fontSize: 13, color: '#94a3b8', margin: 0 }}>
          {emptyNote ?? 'No constraints recorded for this version.'}
        </p>
      )}
    </div>
  );
}
